import states, { State } from 'modules/common/constants/states';

export const TAX_ORGANIZER_YEAR_2024 = 2024;
export const TAX_ORGANIZER_YEAR_2025 = 2025;

// The tax year currently being filed
export const getCurrentTaxYear = (): number => new Date().getFullYear() - 1;

export const documentTypesITR = [
    // Tax forms
    '1040',
    '1042-S',
    '1095-A',
    '1097-BTC',
    '1098',
    '1098-C',
    '1098-E',
    '1098-T',
    '1099',
    '1099-A',
    '1099-B',
    '1099-C',
    '1099-DIV',
    '1099-G',
    '1099-INT',
    '1099-K',
    '1099-LTC',
    '1099-MISC',
    '1099-NEC',
    '1099-OID',
    '1099-PATR',
    '1099-Q',
    '1099-R',
    '1099-S',
    '1099-SA',
    '1099QA',
    '2439',
    '3921',
    '3922',
    '5498-SA',
    // W-2 forms
    'W-2',
    'W-2c',
    'W-2G',
    // Railroad and SSA forms
    'RRB-1042S',
    'RRB-1099',
    'RRB-1099-R',
    'SSA-1042S',
    'SSA-1099',
    // Schedules
    'SCHEDULE_K-1',
    'SCHEDULE_C',
    'SCHEDULE_E',
    // Other documents
    'CONSOLIDATED_BROKERAGE_STATEMENT',
    'PROFIT_LOSS_STATEMENT',
    'SETTLEMENT_STATEMENT',
    'VEHICLE_PURCHASE_OR_LEASE_AGREEMENT',
    // ITR organizer specific document types
    'MEMBER_ID',
    'SPOUSE_ID',
    'PRIOR_YEAR_ITR',
    'QSBS',
    'OTHER',
    // ITR organizer upload option document types
    'VEHICLE_INTEREST_STATEMENT',
    'PROPERTY_TAX_RECEIPT',
    'CHILDCARE_INVOICE',
    'ITR_LLC_PROFIT_LOSS',
    'ITR_RENTAL_PROFIT_LOSS',
    // Settlement document types (distinct for each use case)
    'HOME_SALE_SETTLEMENT',
    'PROPERTY_SALE_SETTLEMENT',
    'LAWSUIT_SETTLEMENT',
    // Additional ITR document types (TAX-2874)
    'CLOSING_STATEMENT',
    'ADOPTION_DOCUMENT',
    'HOME_IMPROVEMENTS_RECEIPT',
    'HOME_ENERGY_PURCHASE_INVOICE',
    'IRS_LETTER',
    'CRYPTOCURRENCY_BROKERAGE_STATEMENT',
    'STOCK_OPTIONS_EXERCISED',
    'CHARITABLE_CONTRIBUTION',
    // Generated organizer summary PDF
    'INDIVIDUAL_TAX_RETURN_ORGANIZER',
    'INDIVIDUAL_TAX_RETURN_FINAL',
    'INDIVIDUAL_TAX_RETURN_MEMBER_REVIEW',
    'TAX_RETURN_EXTENSION_FILING_CONFIRMATION',
] as const;

export type DocumentTypeITR = (typeof documentTypesITR)[number];

export const SSNFormat = '###-##-####';

export const FILING_STATUSES = [
    { value: 'Single', label: 'Single' },
    { value: 'MFJ', label: 'Married filing jointly' },
    { value: 'MFS', label: 'Married filing separately' },
    { value: 'HH', label: 'Head of household' },
    { value: 'Widow', label: 'Qualifying widow(er) with dependent child' },
];

function createOrderedSignatureStates(localStates: State) {
    const modifiedStates = {
        ...localStates,
        FED: 'Federal',
        NYC: 'New York City',
    };
    const sortedEntries = Object.entries(modifiedStates).sort();

    const orderedStates = sortedEntries.reduce<{ [key: string]: string }>((obj, [key, value]) => {
        return { ...obj, [key]: value };
    }, {});

    return orderedStates;
}

export const signatureStates = createOrderedSignatureStates(states);
